<p-toast></p-toast>
<div class="card">
    <div class="form-heading">
        <h5>{{'FARMER_APPLICATION_DETAILS' | translate}}</h5>
    </div>

    <div *ngIf="applicationDetails && (dimicadaLogin || ddAssociateLogin)" class="card my-2">
        <div *ngIf="applicationDetailsForViewOnly?.FarmerPersonalData" class="personal-details-container">
            <div class="flex justify-content-center detail-info-header py-2">
                <h5>{{'PERSONAL_DETAILS' | translate}}</h5>
            </div>
            <div class="p-fluid p-formgrid grid px-3">
                <div class="field col-12 md:col-3">
                    <label>{{'FARMER_NAME'| translate}}</label>
                    <p>{{ applicationDetailsForViewOnly?.FarmerPersonalData?.Name }}</p>
                </div>
                <div class="field col-12 md:col-3">
                    <label>{{'FATHER_NAME'| translate}}</label>
                    <p>{{ applicationDetailsForViewOnly?.FarmerPersonalData?.Father_name }}</p>
                </div>
                <div class="field col-12 md:col-3">
                    <label>{{'MOTHER_NAME'| translate}}</label>
                    <p>{{ applicationDetailsForViewOnly?.FarmerPersonalData?.Mother_Name }}</p>
                </div>
                <div class="field col-12 md:col-3">
                    <label>{{'SEX'| translate}}</label>
                    <p>{{ applicationDetailsForViewOnly?.FarmerPersonalData?.Gender }}</p>
                </div>
                <div class="field col-12 md:col-3">
                    <label>{{'DATE_OF_BIRTH'| translate}}</label>
                    <p>{{ applicationDetailsForViewOnly?.FarmerPersonalData?.DOB | date:'mediumDate' }}</p>
                </div>
                <div class="field col-12 md:col-3">
                    <label>{{'MOBILE'| translate}}</label>
                    <p>{{ applicationDetailsForViewOnly?.FarmerPersonalData?.Mobile }}</p>
                </div>
                <div class="field col-12 md:col-3">
                    <label>{{'EMAIL'| translate}}</label>
                    <p>{{ applicationDetailsForViewOnly?.FarmerPersonalData?.Email_ID }}</p>
                </div>
                <div class="field col-12 md:col-3">
                    <label>{{'EMAIL'| translate}}</label>
                    <p>{{ applicationDetailsForViewOnly?.FarmerPersonalData?.Aadhar_No }}</p>
                </div>
                <div class="field col-12 md:col-3">
                    <label>{{'AADHAR_NO'| translate}}</label>
                    <p>{{ applicationDetailsForViewOnly?.FarmerPersonalData?.Email_ID }}
                        <a *ngIf="applicationDetailsForViewOnly?.FarmerPersonalData
                              ?.Aadhaar_Copy_Upload" style="cursor: pointer" [href]="
                            applicationDetailsForViewOnly?.FarmerPersonalData
                              ?.Aadhaar_Copy_Upload
                          " target="_blank">&nbsp;<i class="pi pi-eye" style="color: slateblue"></i></a>
                    </p>
                </div>
                <div class="field col-12 md:col-3">
                    <label>{{'VILLAGE'| translate}}</label>
                    <p>{{ applicationDetailsForViewOnly?.FarmerPersonalData?.Village_Code }}</p>
                </div>
                <div class="field col-12 md:col-3">
                    <label>{{'BLOCK'| translate}}</label>
                    <p>{{ applicationDetailsForViewOnly?.FarmerPersonalData?.Block }}</p>
                </div>
                <div class="field col-12 md:col-3">
                    <label>{{'DISTRICT'| translate}}</label>
                    <p>{{ applicationDetailsForViewOnly?.FarmerPersonalData?.District }}</p>
                </div>
                <div class="field col-12 md:col-3">
                    <label>{{'CASTE'| translate}}</label>
                    <p>{{ applicationDetailsForViewOnly?.FarmerPersonalData?.Caste_Code }}
                        <a *ngIf="applicationDetailsForViewOnly?.FarmerPersonalData
                              ?.casteCertificate_Uploaded" style="cursor: pointer" [href]="
                            applicationDetailsForViewOnly?.FarmerPersonalData
                              ?.casteCertificate_Uploaded
                          " target="_blank">&nbsp;<i class="pi pi-eye" style="color: slateblue"></i></a>
                    </p>
                </div>
                <div class="field col-12 md:col-3">
                    <label>{{'ADDRESS'| translate}}</label>
                    <p>{{ applicationDetailsForViewOnly?.FarmerPersonalData?.Address }}</p>
                </div>
                <div class="field col-12 md:col-3">
                    <label>{{'PINCODE'| translate}}</label>
                    <p>{{ applicationDetailsForViewOnly?.FarmerPersonalData?.Pin_Code }}</p>
                </div>
                <div class="field col-12 md:col-3">
                    <label>{{'PPP_ID'| translate}}</label>
                    <p>{{ applicationDetailsForViewOnly?.FarmerPersonalData?.PPP_ID }}
                        <a *ngIf="applicationDetailsForViewOnly?.FarmerPersonalData
                              ?.ID_Proof_FilePath" style="cursor: pointer" [href]="
                            applicationDetailsForViewOnly?.FarmerPersonalData
                              ?.ID_Proof_FilePath
                          " target="_blank">&nbsp;<i class="pi pi-eye" style="color: slateblue"></i></a>
                    </p>
                </div>
                <div class="field col-12 md:col-3">
                    <label>{{'MFMB_NO'| translate}}</label>
                    <p>{{ applicationDetailsForViewOnly?.FarmerPersonalData?.MFMBNo }}</p>
                </div>
                <div class="field col-12 md:col-3">
                    <label>{{'APPLICATION_TYPE'| translate}}</label>
                    <p>{{ applicationDetailsForViewOnly?.AppType }}</p>
                </div>
            </div>
        </div>

        <div *ngIf="applicationDetailsForViewOnly?.FarmerLand && applicationDetailsForViewOnly.FarmerLand.length > 0"
            class="land-details-container card my-2">
            <div class="flex justify-content-center detail-info-header py-2">
                <h5>{{'LAND_DETAILS' | translate}}</h5>
            </div>
            <p-table [value]="applicationDetailsForViewOnly?.FarmerLand" [rows]="5" [paginator]="false" [rowHover]="true"
                currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
                [showCurrentPageReport]="true" [scrollable]="true" scrollHeight="applicationDetails.FarmerLand.length == 1 ? '100px' : applicationDetails.FarmerLand.length == 2 ? '200px' ? '250px'" responsiveLayout="scroll"
                [resizableColumns]="true" styleClass="p-datatable-gridlines" [tableStyle]="{'min-width': '80rem'}">
                <ng-template pTemplate="header">
                    <tr>
                        <th style="text-align: center; font-size: 0.7rem;">{{'CHECK_OWNER_DETAILS_WITH_LAND_REVENUE_DEPARTMENT' | translate}}</th>
                        <th>{{'MEMBER_SNO' | translate}}</th>
                        <th>{{'OWNER_NAME' | translate}}</th>
                        <th>{{'VILLAGE' | translate}}</th>
                        <th>{{'KHEWAT' | translate}}</th>
                        <th>{{'KHEWAT_AREA' | translate}}</th>
                        <th>{{'KHEWAT_BHAG' | translate}}</th>
                        <th>{{'OWNER_HISSA' | translate}}</th>

                        <th>{{'MORABBA_NO' | translate}}</th>
                        <th>{{'KILLA_NO' | translate}}</th>

                        <th>{{'TOTAL_KANALS' | translate}}</th>
                        <th>{{'TOTAL_MARLAS' | translate}}</th>

                        <th>{{'APPLIED_KANALS' | translate}}</th>
                        <th>{{'APPLIED_MARLAS' | translate}}</th>
                        <th>{{'APPLIED_AREA' | translate}}</th>

                        <th>{{'CROP_TYPE' | translate}}</th>
                        <th>{{'YEAR' | translate}}</th>

                        <th>{{'LAND_DOC' | translate}}</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-item>
                    <tr>
                        <td>
                            <div class="flex justify-content-center">
                              <button pButton type="button" (click)="beforeCheckingLandStatus(item)"
                                  class="p-button-rounded p-button-accent p-button-primary p-button-rounded"
                                  pTooltip="{{ 'CHECK_OWNER_DETAILS_WITH_LAND_REVENUE_DEPARTMENT' | translate }}" icon="pi pi-eye"></button>
                            </div>
                        </td>
                        <td>{{ item?.memberID }}</td>
                        <td>{{ item?.OwnerName }}</td>
                        <td>{{ item?.Village }}</td>
                        <td>{{ item?.Khewat }}</td>
                        <td>{{ item?.KhewatArea }}</td>
                        <td>{{ item?.Bhag }}</td>
                        <td>{{ item?.OwnerHissa }}</td>

                        <td>{{ item?.morabbaNo }}</td>
                        <td>{{ item?.killaNo }}</td>

                        <td>{{ item?.TotalkanalinKhasra }}</td>
                        <td>{{ item?.TotalmarlainKhasra }}</td>

                        <td>{{ item?.kanal }}</td>
                        <td>{{ item?.marla }}</td>
                        <td>{{ item?.totalArea }}</td>

                        <td>{{ item?.cropType }}</td>
                        <td>{{ item?.Year }}</td>
                        <td>
                            <div *ngIf="item?.landPath != '' && item.landPath != null" class="hidden-print">
                                <a style="cursor: pointer" [href]="item?.landPath" target="_blank"><i class="pi pi-eye"
                                        style="color: slateblue"></i></a>
                            </div>
                            <div *ngIf="item?.landPath == '' || item.landPath == null" class="hidden-print">
                                <p>{{'N/A' |
                                    translate}}</p>
                            </div>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>

        <div *ngIf="existingMIDetails && existingMIDetails.length > 0" class="existing-details-container card my-2">
            <div class="flex justify-content-center detail-info-header py-2">
                <h5>{{'EXISTING_MI_DETAILS' | translate}}</h5>
            </div>
            <p-table [value]="existingMIDetails" [rows]="5" [paginator]="false" [rowHover]="true"
                currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
                [showCurrentPageReport]="true" [scrollable]="true" scrollHeight="existingMIDetails.length == 1 ? '100px' : existingMIDetails.length == 2 ? '200px' ? '250px'" responsiveLayout="scroll"
                [resizableColumns]="true" styleClass="p-datatable-gridlines" [tableStyle]="{'min-width': '80rem'}">
                <ng-template pTemplate="header">
                    <tr>
                        <th>{{'PROGRAM_NAME' | translate}}</th>
                        <th>{{'MORABBA_NO' | translate}}</th>
                        <th>{{'KILLA_NO' | translate}}</th>
                        <th>{{'TOTAL_AREA_IN_ACRE' | translate}}</th>
                        <th>{{'IS_SUBSIDY_AVAIL' | translate}}</th>
                        <th>{{'YEAR' | translate}}</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-item>
                    <tr>
                        <td>{{ item?.ProgrammeName }}</td>
                        <td>{{ item?.Morabba_No }}</td>
                        <td>{{ item?.Killa_No }}</td>
                        <td>{{ item?.TotalArea }}</td>
                        <td>{{ item?.Is_Subsidy_Avail }}</td>
                        <td>{{ item?.Year_subsidy }}</td>
                    </tr>
                </ng-template>
            </p-table>
        </div>

        <div *ngIf="applicationDetailsForViewOnly?.New_MI_Datas && applicationDetailsForViewOnly.New_MI_Datas.length > 0" class="onfarm-details-container card my-2">
            <div class="flex justify-content-center detail-info-header py-2">
                <h5>{{'ON_FARMER_MI_COMPONENTS_AND_VENDOR_DETAILS' | translate}}</h5>
            </div>
            <p-table [value]="applicationDetailsForViewOnly?.New_MI_Datas" [rows]="5" [paginator]="false"
                [rowHover]="true"
                currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
                [showCurrentPageReport]="true" [scrollable]="true" scrollHeight="existingMIDetails.length == 1 ? '100px' : existingMIDetails.length == 2 ? '200px' ? '250px'" responsiveLayout="scroll"
                [resizableColumns]="true" styleClass="p-datatable-gridlines" [tableStyle]="{'min-width': '80rem'}">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>{{'PROGRAMME_NAME' | translate}}</th>
                            <th>{{'LAND_DATA' | translate}}</th>
                            <th>{{'VENDOR_NAME' | translate}}</th>
                            <th>{{'TOTAL_AREA_IN_ACRE' | translate}}</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-item>
                        <tr>
                            <td>{{ item.programName }}</td>
                            <td>{{ item.landData }}</td>
                            <td>{{ item.miVendorName }}</td>
                            <td>{{ item.totalArea }}</td>
                        </tr>
                    </ng-template>
            </p-table>
        </div>
    </div>

    <div class="card my-2">
        <div class="consent-form border" id="printableArea">
            <div class="header border p-fluid p-formgrid justify-content-center top-header" style="display: flex; flex-wrap:wrap">
                <!-- <div class="field md:col-3 col-12">
                    <p-image *ngIf="applicationDetailsForViewOnly?.FarmerPersonalData?.FdQRCodePath"
                    [src]="applicationDetailsForViewOnly?.FarmerPersonalData?.FdQRCodePath" alt="Image" width="150"
                    height="150px" iconPos="left" [preview]="true"></p-image>
                </div> -->
                <div class="field md:col-9 col-12 top-header-text">
                    <p class="header-val">{{'VENDOR_ESTIMATION_FORM_FOR_MICRO_IRRIGATION_SCHEME' | translate}}</p>
                    <p class="header-date">{{'REG_DATE' | translate}} : {{ applicationDetailsForViewOnly?.RegDate | date: "mediumDate" }}</p>
                </div>
                <div class="field md:col-3 col-12">
                    <p-image *ngIf="applicationDetailsForViewOnly?.FarmerPersonalData?.Farmer_Photo"
                    [src]="applicationDetailsForViewOnly?.FarmerPersonalData?.Farmer_Photo" alt="Image" width="150"
                    height="150px" iconPos="left" [preview]="true"></p-image>
                </div>
            </div>

            <!-- <div class="header border flex justify-content-center">
                <div class="md:col-3 col-12 heading-date">{{ currentDateTime | date }}</div>
                <div class="md:col-9 col-12 heading-content">
                    {{'VENDOR_ESTIMATION_FORM_FOR_MICRO_IRRIGATION_SCHEME'| translate}}
                </div>
                <div class="md:col-3 col-12">
                    <p-image *ngIf="applicationDetailsForViewOnly?.FarmerPersonalData?.Farmer_Photo"
                        [src]="applicationDetails?.FarmerPersonalData?.Farmer_Photo" alt="Image" width="150"
                        height="150px" iconPos="left" [preview]="true"></p-image>
                </div>
            </div> -->
            <div class="sub-header ">
                <table class="border">
                    <tr>
                        <td>
                            <p class="head">{{'APPLICATION_NO'| translate}}</p>
                            <a class="bold appId" (click)="onClickApp()">{{applicationDetails?.AppID}}</a>
                        </td>
                        <td>
                            <p class="head">{{'VENDOR_NAME'| translate}}</p>
                            <p class="bold">{{applicationDetails?.VendorName}}</p>
                        </td>
                        <td>
                            <p class="head">{{'PROGRAMME_NAME'| translate}}</p>
                            <p class="bold">
                                {{applicationDetails?.ProgrammeName}}
                            </p>
                        </td>
                    </tr>
                </table>
                <!-- <div class="col-3 border">
          </div>
          <div class="col-4 border">
  
          </div>
          <div class="col-5 border">
  
          </div> -->
            </div>

            <!-- member details -->
            <ng-container
                *ngIf="applicationDetails?.EstimationComponentDetail && applicationDetails?.EstimationComponentDetail.length>0">

                <div class="print border bold">{{'ESTIMATION_COMPONENT_DETAIL'| translate}}</div>
                <div class="table">
                    <table class="border">
                        <tr>
                            <th>{{'CAT_ID'| translate}}</th>
                            <th>{{'CAT_NAME'| translate}}</th>
                            <th>{{'COMPONENT_ID'| translate}}</th>
                            <th>{{'COMPONENT_NAME'| translate}}</th>
                            <th>{{'SIZE_ID'| translate}}</th>
                            <th>{{'SIZE'| translate}}</th>
                            <th>{{'PRICE'| translate}}</th>
                            <th>{{'QUANTITY'| translate}}</th>
                            <th>{{'GST'| translate}}</th>
                        </tr>
                        <tr *ngFor="let item of applicationDetails?.EstimationComponentDetail">
                            <td>{{item.CatID}}</td>
                            <td>{{item.CatName}}</td>
                            <td>{{item.ComponentID}}</td>
                            <td>{{item.ComponentName}}</td>
                            <td>{{item.SizeID}}</td>
                            <td>{{item.Size}}</td>
                            <td>{{item.Price}}</td>
                            <td>{{item.Quantity}}</td>
                            <td>{{item.GST}}</td>
                        </tr>
                    </table>
                </div>
            </ng-container>
            <!-- member details end -->

            <ng-container *ngIf="applicationDetails">

                <div class="print border bold ">{{'ESTIMATION_DETAILS'| translate}}</div>
                <div class="table">
                    <table class="border">
                        <tr>
                            <td>
                                <p class="bold">{{'VENDOR_ASSOCIATE_ID'| translate}}</p>
                                <p>{{applicationDetails?.VendorAssociateID}}</p>
                            </td>
                            <td>
                                <p class="bold">{{'FARMER_SHARE_AMOUNT'| translate}}</p>
                                <p>{{applicationDetails?.FarmerShareAmount}}</p>
                            </td>
                            <td>
                                <p class="bold">{{'COMPONENT_AMOUNT'| translate}}</p>
                                <p>{{applicationDetails?.ComponentAmount}}</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p class="bold">{{'TAX_RATE'| translate}}</p>
                                <p>{{applicationDetails?.TaxRate}}</p>
                            </td>
                            <td>
                                <p class="bold">{{'DISCOUNT_RATE'| translate}}</p>
                                <p>{{applicationDetails?.DiscountRate}}</p>
                            </td>
                            <td>
                                <p class="bold">{{'OTHER_TRANSPORT_EXPENSES'| translate}}</p>
                                <p>{{applicationDetails?.TransportOtherExpenses}}</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p class="bold">{{'MAX_SUBSIDY_AMOUNT'| translate}}</p>
                                <p>{{applicationDetails?.MaxSubSidyAmount}}</p>
                            </td>
                            <td>
                                <p class="bold">{{'MI_AREA'| translate}}</p>
                                <p>{{applicationDetails?.MIArea}}</p>
                            </td>
                            <td>
                                <p class="bold">{{'CROP_ID'| translate}}</p>
                                <p>{{applicationDetails?.CropID}}</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p class="bold">{{'LAND_MAP_PATH'| translate}}</p>
                                <p><a href="{{applicationDetails?.LandMapPath}}" target="_blank">open path</a></p>
                            </td>
                            <td>
                                <p class="bold">{{'LATITUDE'| translate}}</p>
                                <p>{{applicationDetails?.Lat}}</p>
                            </td>
                            <td>
                                <p class="bold">{{'LONGITUDE'| translate}}</p>
                                <p>{{applicationDetails?.Long}}</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p class="bold">{{'PLANT_SPACING'| translate}}</p>
                                <p>{{applicationDetails?.PlantSpacing}}</p>
                            </td>
                            <td>
                                <p class="bold">{{'ROW_SPACING'| translate}}</p>
                                <p>{{applicationDetails?.RowSpacing}}</p>
                            </td>
                            <td>
                                <p class="bold">{{'REMARKS'| translate}}</p>
                                <p>{{applicationDetails?.Remarks}}</p>
                            </td>
                        </tr>
                    </table>
                </div>
            </ng-container>



        </div>
        <!-- <div class="flex justify-content-around mb-2">
            <button pButton pRipple icon="pi pi-print" type="submit" label="Print"
              (click)="onPrint('printableArea')"></button>
        </div> -->

        <!-- pre-estimate-survey -->
        <div class="pre-estimate-form border my-4" *ngIf="preEstimationDataArray.length > 0">
            <div class="mt-2 form-name">
                <h5> {{'PRE_ESTIMATE_SURVEY' | translate}} </h5>
            </div>

            <div class="consent-form" *ngFor="let preEstimateDetails of preEstimationDataArray">
                <ng-container>
                    <div class="table">
                        <table class="border">
                            <tr>
                                <td>
                                    <p class="bold">{{'APP_ID' | translate}}</p>
                                    <p>{{ preEstimateDetails?.AppID }}</p>
                                </td>
                                <td>
                                    <p class="bold">{{'PROGRAMME_NAME' | translate}}</p>
                                    <p>{{ preEstimateDetails?.ProgramName }}</p>
                                </td>
                                <td>
                                    <p class="bold">{{'SOIL_TYPE' | translate}}</p>
                                    <p>{{ preEstimateDetails?.SoilType }}</p>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <p class="bold">{{'CROP_TYPE' | translate}}</p>
                                    <p>
                                        {{ preEstimateDetails?.selectedCropType }}
                                    </p>
                                </td>
                                <td>
                                    <p class="bold">{{'CROP_NAME' | translate}}</p>
                                    <p>
                                        {{ preEstimateDetails?.selectedCrop }}
                                    </p>
                                </td>
                                <td>
                                    <p class="bold">{{'WATER_SOURCE' | translate}}</p>
                                    <p>{{ preEstimateDetails?.WaterSource }}</p>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <p class="bold">{{'WATER_PRESSURE' | translate}}</p>
                                    <p>{{ preEstimateDetails?.WaterPressure }}</p>
                                </td>
                                <td>
                                    <p class="bold">{{'WATER_QUALITY' | translate}}</p>
                                    <p>{{ preEstimateDetails?.WaterQuality }}</p>
                                </td>
                                <td>
                                    <p class="bold">{{'WATER_REQ' | translate}}</p>
                                    <p>{{ preEstimateDetails?.WaterQuantity }}</p>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <p class="bold">{{'PH' | translate}}</p>
                                    <p>{{ preEstimateDetails?.PH }}</p>
                                </td>
                                <td>
                                    <p class="bold">{{'EC' | translate}}</p>
                                    <p>{{ preEstimateDetails?.EC }}</p>
                                </td>
                                <td>
                                    <p class="bold">{{'DATE_OF_SURVEY' | translate}}</p>
                                    <p>{{ preEstimateDetails?.DateOfSurvey }}</p>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <p class="bold">{{'PLANT_SPACING' | translate}}</p>
                                    <p>{{ preEstimateDetails?.PlantSpacing }}</p>
                                </td>

                                <td>
                                    <p class="bold">{{'ROW_SPACING' | translate}}</p>
                                    <p>{{ preEstimateDetails?.RowSpacing }}</p>
                                </td>
                            </tr>
                        </table>
                        <div class="print border bold">
                            {{'LIST_GPS_COORDINATES' | translate}}
                        </div>
                        <div class="table"
                            *ngFor="let array of preEstimateDetails?.newGPSArray?.gpsArray; let i = index">
                            <h6 class="mt-1 mb-0">Table {{ i + 1}}</h6>
                            <table class="border">
                                <tr>
                                    <th>{{'CORNER_ID' | translate}}</th>
                                    <th>{{'LATITUDE' | translate}}</th>
                                    <th>{{'LONGITUDE' | translate}}</th>
                                </tr>
                                <tr *ngFor="let item of array">
                                    <td>{{item.CornerID}}</td>
                                    <td>{{item.Latitude}}</td>
                                    <td>{{item.Longitude}}</td>
                                </tr>
                            </table>
                        </div>
                        <div class="p-fluid p-formgrid grid hidden-print" *ngIf="showMapPreEstimate">
                            <div class="field col-12 md:col-12">
                                <p-gmap [options]="preEstimateDetails?.newGPSArray?.preEstimateOption" type="satellite"
                                    [overlays]="preEstimateDetails?.newGPSArray?.preEatimateOverlays"
                                    [style]="{'width':'100%','height':'320px'}"></p-gmap>
                            </div>
                        </div>
                        <div class="print border bold">{{'LIST_IMAGE_PATH' | translate}}</div>
                        <div class="p-fluid p-formgrid grid" style="padding:10px">
                            <div *ngFor="let image of preEstimateDetails.listImagePath; let index = index;"
                                class="field m-3" key="index">
                                <img [src]="image.ImagePath" alt='image' style="cursor: pointer"
                                    (click)="imageClick(index, preEstimateDetails.listImagePath)"
                                    style="max-width: 300px; max-height: 300px;" />
                                <div class="flex flex-wrap justify-content-center">
                                    <div>{{image.DocumentType}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container>

            </div>
        </div>
        <!-- pre-estimate-survey end-->
    </div>
</div>

<div class="card proDataCalculation">
    <!-- <div> -->
    <!-- pro data calculations -->
    <div class="my-2 proDataButton">
        <button (click)="proDataCalculation()" pButton pRipple type="submit"
            label="{{'VIEW_PRO_DATA_MAX_SUBSIDY_CAL'| translate}}" class="p-button-info mr-2 mb-2"></button>
    </div>
    <!-- <div *ngIf="showProDataCalError" class="invalid-feedback mb-2">
            <div *ngIf="finalEstimationControls?.rowSpacing?.errors?.required">Row Spacing is
                required
            </div>
            <div *ngIf="finalEstimationControls?.plantSpacing?.errors?.required">Plant Spacing is
                required
            </div>
            <div *ngIf="finalEstimationControls?.MIArea?.errors?.required">MIArea Spacing is
                required
            </div>
        </div> -->

    <div *ngIf="isProDataCalculated" class="p-fluid p-formgrid grid card proData">
        <div class="field col-12 md:col-3">
            <label htmlFor="pro-data">{{'PRO-DATA_MAX-SUBSIDY_FORMULA'| translate}}:</label>
            <p><label>{{ proCalculatedData.Formula }}</label></p>
        </div>

        <div class="field col-12 md:col-3">
            <label htmlFor="output">{{'OUTPUT'| translate}} :</label>
            <p><label>{{ proCalculatedData.Output }}</label></p>
        </div>

        <div class="field col-12 md:col-2">
            <label htmlFor="amount">{{'AMOUNT'| translate}} :</label>
            <p><label>Rs. {{ proCalculatedData.Amount }}/-</label></p>
        </div>

        <div class="field col-12 md:col-1">
            <label htmlFor="maxSubsidy">{{'MAXIMUN_SUBSIDY'| translate}} :</label>
            <p><label>Rs. {{ proCalculatedData.maxSubsidy }}/-</label></p>
        </div>

        <div class="field col-12 md:col-1">
            <label htmlFor="transportAmount">{{'TRANSPORT_AMOUNT'| translate}} :</label>
            <p><label>Rs. {{ proCalculatedData.TransportAmount }}/-</label></p>
        </div>

        <div class="field col-12 md:col-2">
            <label htmlFor="result">{{'RESULT'| translate}} :</label>
            <p><label>{{ proCalculatedData.Result }}</label></p>
        </div>

    </div>

    <!-- </div> -->
</div>

<div class="card" reflow="true">
    <div *ngIf="viewWorkFlowAllStatus">
        <app-work-flow-all-status [applicationId]="applicationDetails?.AppID"></app-work-flow-all-status>
    </div>

    <button *ngIf="!viewWorkFlowAllStatus" pButton type="button" label="{{'VIEW_APPLICATION_STATUS' | translate}}"
        class="p-button-secondary" (click)="workFlowAllStatus()"></button>
</div>

<div class="card" *ngIf="isActionSectionEnabled">
    <p-toolbar styleClass="mb-4">
        <ng-template pTemplate="left">
            <!-- <button pButton icon="pi pi-fw pi-plus" label="Add Bank Details" (click)="openNew()"
                class="p-button-success"></button> -->
            <!-- <button pButton pRipple  icon="pi pi-trash" class="ml-4 p-button-danger" (click)="deleteSelectedProducts()" [disabled]="!selectedBankAccounts || !selectedBankAccounts.length"></button> -->
        </ng-template>
        <ng-template pTemplate="right">
            <p-dropdown [options]="items" [(ngModel)]="selectedStatus" optionLabel="status" class="mr-3" (onChange)="onSelectStatus()"></p-dropdown>
            <textarea id="description" [(ngModel)]="remarks" placeholder="{{'REMARKS'| translate}}" pInputTextarea
                required rows="3" cols="20" class="mr-3"></textarea>
            <button pButton pRipple label="{{'SUBMIT'| translate}}" (click)="handleClick()"
                class="p-button-help"></button>
        </ng-template>
    </p-toolbar>
</div>

<p-galleria [value]="imgVal" [(visible)]="displayCustom" [(activeIndex)]="activeIndex"
    [responsiveOptions]="responsiveOptions" [containerStyle]="{'max-width': '850px'}" [circular]="true"
    [fullScreen]="true" [showItemNavigators]="true" [showThumbnails]="false" [baseZIndex]="100000">
    <ng-template pTemplate="item" let-item>
        <img [src]="item.ImagePath" style="width: 100%; display: block;" />
    </ng-template>
</p-galleria>


<p-dialog header="{{ 'LAND_OWNER_DETAILS' | translate }}" [(visible)]="displayLandOwnerDialog" [modal]="true" [style]="{width: '95%',height:'auto'}"
    [maximizable]="true" [draggable]="true" [resizable]="true" (onHide)="onCloseLandOwnerDialog()">
    <div class="input-container">
      <input type="text" placeholder="Enter Kewat No" [(ngModel)]="kewatNo" />
      <button pButton pRipple type="button" type="submit" label="{{'Get Owner Details' | translate}}"
                class="p-button-success mr-2 mb-2" (click)="submitKewatNo()"></button>
      <!-- <button (click)="submitKewatNo()">Submit</button> -->
    </div>
    
    <p-progressBar mode="indeterminate" *ngIf="isLandOwnerDetFetching"></p-progressBar>
    <div *ngIf="isLandOwnerDetFetching" class="loading-text">
      <p>{{ loadingText }}</p>
    </div>
    <ng-template pTemplate="content">
      <div *ngIf="landOwnerDetails?.length > 0 && !isLandOwnerDetFetching" class="p-fluid p-formgrid justify-content-center">
        <p-table #landOwnerDataTable [value]="landOwnerDetails" [rows]="10" [paginator]="true" [globalFilterFields]="[
            'Owner_Name',
            'Bhag',
            'Khewat',
            'khewat_area',
            'owner_hissa',
            'TotalArea',
            'Year',
            ]" [rowHover]="true" dataKey="uiqueId"
          currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
          [showCurrentPageReport]="true" responsiveLayout="scroll">
          <ng-template pTemplate="caption">
            <div class="grid p-fluid mt-2 justify-content-between">
              <!-- Left side -->
              <div class="field col-12 md:col-6">
                <p class="pt-2 " [style]="{'color': 'rgb(168, 32, 32)', 'font-weight': 'bold', 'font-size': '1.0rem'}">{{
                  'Fetched Land Owner Details from Jamabandi Portal' }}</p>
              </div>
              <!-- Middle section for buttons -->
              <div class="field col-0 md:col-0">
              </div>
              <!-- Right side for search -->
              <div class="field col-12 md:col-6 align-items-center justify-content-end">
                <span class="p-input-icon-left">
                  <i class="pi pi-search"></i>
                  <input pInputText type="text"
                    (input)="landOwnerDataTable.filterGlobal($any($event.target).value, 'contains')"
                    placeholder="{{'SEARCH'| translate}}" />
                </span>
              </div>
            </div>
          </ng-template>
          <ng-template pTemplate="header">
            <tr>
              <th>{{'S.No'| translate}}</th>
              <th>{{'KHEWAT'| translate}}</th>
              <th>{{'OWNER_NAME'| translate}}</th>
              <th>{{'BHAG'| translate}}</th>
              <th>{{'KHEWAT_AREA'| translate}}</th>
              <th>{{'OWNER_HISSA_IN_ACRES'| translate}}</th>
              <th>{{'TOTAL_APPLIED_AREA_IN_ACRES'| translate}}</th>
              <th>{{'FARMER_APPLIED_AREA_IN_ACRES'| translate}}</th>
              <th>{{'YEAR'| translate}}</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-product let-expanded="expanded" let-i="rowIndex">
            <tr>
              <td>{{ i + 1 }}</td>
              <td>{{product?.Khewat}}</td>
              <td>{{product?.Owner_Name}}</td>
              <td>{{product?.Bhag}}</td>
              <td>{{product?.khewat_area}}</td>
              <td>{{product?.owner_hissa | number:'0.3-3'}}</td>
              <td>{{product?.TotalArea | number:'0.3-3'}}</td>
              <td>{{product?.TotalAreaFarmer | number:'0.3-3'}}</td>
              <td>{{product?.Year}}</td>
            </tr>
          </ng-template>
        </p-table>

        <div *ngIf="landDetailedInfo.length > 0">
          <p-table #landOwnerDetailsDataTable [value]="landDetailedInfo" [rows]="10" [paginator]="true"
            [globalFilterFields]="[
            'khatoni',
            'khewat',
            'killa',
            'must',
            'knl',
            'mrl',
            'period',
            ]" [rowHover]="true" dataKey="killa" 
            currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
            [showCurrentPageReport]="true" responsiveLayout="scroll">
            <ng-template pTemplate="caption">
              <div class="grid p-fluid mt-2 justify-content-between">
                <!-- Left side -->
                <div class="field col-12 md:col-6">
                  <p class="pt-2 " [style]="{'color': 'rgb(168, 32, 32)', 'font-weight': 'bold', 'font-size': '1.0rem'}">
                    {{
                    'Fetched Land Details from Jamabandi Portal' }}</p>
                </div>
                <!-- Middle section for buttons -->
                <div class="field col-0 md:col-0">
  
                </div>
                <!-- Right side for search -->
                <div class="field col-12 md:col-6 align-items-center justify-content-end">
                  <span class="p-input-icon-left">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text"
                      (input)="landOwnerDetailsDataTable.filterGlobal($any($event.target).value, 'contains')"
                      placeholder="{{'SEARCH'| translate}}" />
                  </span>
                </div>
              </div>
            </ng-template>
            <ng-template pTemplate="header">
              <tr>
                <th>{{'S.No'| translate}}</th>
                <th>{{'KHATONI'| translate}}</th>
                <th>{{'KHEWAT'| translate}}</th>
                <th>{{'MORABBA_NUMBER'| translate}}</th>
                <th>{{'KILLA_NO'| translate}}</th>
                <th>{{'KANALS'| translate}}</th>
                <th>{{'MARLAS'| translate}}</th>
                <th>{{'YEAR'| translate}}</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-product let-expanded="expanded" let-i="rowIndex">
              <tr>
                <td>{{ i + 1 }}</td>
                <td>{{product?.khatoni}}</td>
                <td>{{product?.khewat}}</td>
                <td>{{product?.must}}</td>
                <td>{{product?.killa}}</td>
                <td>{{product?.knl}}</td>
                <td>{{product?.mrl}}</td>
                <td>{{product?.period}}</td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>


      <div *ngIf="landOwnerDetails.length == 0 && !isLandOwnerDetFetching" class="p-fluid p-formgrid justify-content-center">
        <div class="field md:col-12 col-12">
          <label [style]="{'color': 'rgb(168, 32, 32)', 'font-weight': 'bold'}">{{ landOwnerDetailsErrorMsg }}</label>
        </div>
      </div>

      <button pButton pRipple type="button" label="{{'CLOSE'| translate}}" class="p-button-secondary" style="float: right;"
        (click)="onCloseLandOwnerDialog()"></button>

    </ng-template>
</p-dialog>